import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { selectedDoctorAtom } from '../shared/selected.doctor';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { specialityServices } from '../shared/speciality.service';
import { selectedTurnItem } from '../shared/selected.turn.items';
import { selectedTurnBase } from '../shared/selected.turn.base';
import { fetchService } from '../adapaters/fetchService';

const useFetchSpecialityServices = () => {
  const [selectedDoctor] = useAtom(selectedDoctorAtom);
  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );

  const [selectedTurn] = useAtom(selectedTurnItem);
  const [turnBase] = useAtom(selectedTurnBase);
  const [specialityService, setSpecialityService] = useAtom(
    specialityServices
  );

  useEffect(() => {
    setSpecialityService();
    if (selectedDoctor) {
      if (selectedTurn && turnBase === 'speciality') {
        fetchService(
          setSpecialityService,
          selectedDepartment,
          selectedDoctor?.doctor?.id
        );
      }
    }
  }, [
    JSON.stringify(selectedDoctor),
    JSON.stringify(turnBase),
    JSON.stringify(selectedTurn),
    JSON.stringify(selectedDepartment),
  ]);

  return specialityService;
};

export default useFetchSpecialityServices;
